import { Button } from '@/components/Button';
import { useUserData } from '@/contexts/UserDataContext';
import { useState } from 'react';

interface YourOwnMessageStepProps {
    onNext: () => void;
}

export const YourOwnMessageStep = ({ onNext }: YourOwnMessageStepProps) => {
    const { updateUserData } = useUserData();
    const [message, setMessage] = useState('');
    const maxChars = 180;

    const handleNext = () => {
        updateUserData({ userMessage: message });
        onNext();
    };

    return (
        <>
            <div className="shrink-0 flex flex-col gap-2 justify-center items-center w-full px-8">
                <div className="relative w-full">
                    <textarea
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        maxLength={maxChars}
                        className='w-full border-2 rounded-[16px] border-osGrey-4 p-4 text-base font-semibold min-h-[150px] max-h-32 resize-none overflow-y-scroll scrollbar-hide focus:border-osBlack outline-osBlack focus:outline-none'
                        rows={1}
                        placeholder="OCD isn't who you are, it's what you've been dealing with ✨..."
                    />
                    <div className="absolute bottom-3 right-3 text-sm text-osGrey-2 font-medium">
                        {message.length}/{maxChars}
                    </div>
                </div>
                <p className='text-sm text-osBlack font-semibold'>you can skip this step</p>
                <Button label="Continue" onClick={handleNext} />
            </div>
        </>
    );
};